import React, { useMemo } from "react";
import FormField from "@adsk/alloy-react-form-field";
import TextInput from "@adsk/alloy-react-text-input";
import { useTranslations } from "../../utils";
import { FormFieldSpacer } from "../../shared/SharedDataInputModal.styles";
import { SubmitError } from "../../shared/types";
import { InputContainer } from "./CreateTemplateFromGlobalTemplateInput.styles";
export var CreateTemplateGlobalTemplateModalInputModal = function (_a) {
    var isSubmitting = _a.isSubmitting, name = _a.name, onNameChange = _a.onNameChange, submitError = _a.submitError;
    var T = useTranslations().T;
    var inputErrorMessage = useMemo(function () {
        var _a;
        var inputErrorMessages = (_a = {},
            _a[SubmitError.DuplicateName] = T.translate("errors.duplicateName"),
            _a[SubmitError.InvalidName] = T.translate("errors.invalidName"),
            _a[SubmitError.NameTooLong] = T.translate("errors.nameTooLong"),
            _a[SubmitError.Other] = T.translate("errors.other"),
            _a);
        return submitError ? inputErrorMessages[submitError] : undefined;
    }, [T, submitError]);
    return (React.createElement(InputContainer, { "data-testid": "CreateTemplateFromGlobalTemplateModal.DataInput" },
        React.createElement(FormFieldSpacer, null,
            React.createElement(FormField, { "data-testid": "CreateTemplateFromGlobalTemplateModal.TemplateName.Label", error: inputErrorMessage || undefined, errorVariant: FormField.ERROR_VARIANTS.CAPTION, label: T.translate("createTemplateModal.templateNameLabel"), required: true, labelVariant: FormField.LABEL_VARIANTS.TOP },
                React.createElement(TextInput, { "data-testid": "CreateTemplateFromGlobalTemplateModal.TemplateName.Input", value: name, onChange: function (e) { return onNameChange(e.target.value); }, disabled: isSubmitting })))));
};
